# frozen_string_literal: true

module Engine
  module Game
    module G1849Boot
    end
  end
end
